import { withLocalePrefix, type ShopLocale } from '../i18n/shopLocale'
import { normalizeProductPublicCode } from '../catalog/routing'

export const mergeSearch = (destination: string, search: string) => {
  if (!search) return destination
  if (!destination.includes('?')) return `${destination}${search}`
  return `${destination}&${search.replace(/^\?/, '')}`
}

export const mapLegacyAdminPath = (pathnameWithoutLocale: string): string | null => {
  if (pathnameWithoutLocale === '/admin' || pathnameWithoutLocale === '/admin/') return '/'
  if (pathnameWithoutLocale.startsWith('/admin/')) {
    return pathnameWithoutLocale.slice('/admin'.length) || '/'
  }
  return null
}

export const isBypassPath = (requestedPathname: string): boolean =>
  requestedPathname === '/login' ||
  requestedPathname.startsWith('/login/') ||
  requestedPathname === '/signup' ||
  requestedPathname.startsWith('/signup/') ||
  requestedPathname === '/dashboard' ||
  requestedPathname.startsWith('/dashboard/') ||
  requestedPathname === '/api' ||
  requestedPathname.startsWith('/api/') ||
  requestedPathname === '/admin' ||
  requestedPathname.startsWith('/admin/')

export const buildLocalizedRedirectDestination = ({
  pathnameWithoutLocale,
  initialSearch,
  locale,
}: {
  pathnameWithoutLocale: string
  initialSearch: string
  locale: ShopLocale
}) => withLocalePrefix(`${pathnameWithoutLocale}${initialSearch}`, locale)

export const normalizeRepeatedShortProductPath = (pathnameWithoutLocale: string): string | null => {
  const segments = String(pathnameWithoutLocale || '')
    .replace(/^\/+|\/+$/g, '')
    .split('/')
    .filter(Boolean)

  if (segments.length < 3) return null
  if (!segments.slice(0, -1).every((segment) => segment.toLowerCase() === 'dp')) return null

  const publicCode = normalizeProductPublicCode(decodeURIComponent(segments[segments.length - 1] ?? ''))
  if (!publicCode) return null

  return `/dp/${encodeURIComponent(publicCode)}`
}
